import { z } from "zod";

export const getTripsByVehiclesPayloadSchema = z.object({
  companyUuid: z.uuid().optional(),
  departmentUuid: z.uuid().optional(),
  from: z.union([z.date(), z.string()]).optional(),
  to: z.union([z.date(), z.string()]).optional(),
});

export type GetTripsByVehiclesPayload = z.infer<
  typeof getTripsByVehiclesPayloadSchema
>;
